"use client";

import { paymentsSchema } from "../../../../lib/types/schema/subscription/paymentSchema";
import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyMePayments } from "./keyMePayments";

export type UseRequestMePaymentsProps = UseRequestQueryProps;

export const useRequestMePayments = ({
  ...props
}: UseRequestMePaymentsProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: paymentsSchema,
      urlBackendPath: "/me/payments",
    },
    queryKey: keyMePayments(),
  }),
});
